export default "__VITE_ASSET__DMDxdhMA__"